import { ICON__eye_solid, ICON__pen } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { FN_FIELD_IMAGE__edit } from '@/pages/page_generation/sidebar/image_asset/_methods/FN_FIELD_IMAGE__edit';
import { FN_IMAGE__get_available_tabs } from '@/utils/_methods/FN_IMAGE__get_available_tabs';
import { FN_IMAGE__get_best_first_tab_for_image_edit } from '@/utils/_methods/FN_IMAGE__get_best_first_tab_for_image_edit';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_GRAPH__BUTTON__image_view_or_edit({ field }: PROPS) {
  /*
   * STORE
   */

  const { g_general__ui_disabled, g_general__layout } = use_slice_ui(['g_general__ui_disabled', 'g_general__layout']);

  /*
   * STATE
   */

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let best_tab = FN_IMAGE__get_best_first_tab_for_image_edit(field);
    FN_FIELD_IMAGE__edit(field, ENUM__page_generation_layout.ASSETS, best_tab);

    UTILS__graph_ui.node__select(field.meta.node_id);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */
  if (field.meta.data__is_linked) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />; //nothing to view
  if (!field.get_has_content()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />; //nothing to view
  if (!field.image__is_initialized) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />; //nothing to view
  if (g_general__layout == ENUM__page_generation_layout.ASSETS) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />; //no need to show button

  /*
   *
   */

  const available_tabs = FN_IMAGE__get_available_tabs(field);

  let not_only_view_available = available_tabs.some(tab => tab != ENUM__page_generation_layout_images_edit_tab.VIEW);

  return (
    <UI_PRIMITIVE__button size={'square-6'} disabled={is_disabled()} variant={'no-border-on-bar'} {...{ onClick }} title="View image">
      {not_only_view_available ? <ICON__pen className="!size-3" /> : <ICON__eye_solid className="!size-3" />}
    </UI_PRIMITIVE__button>
  );
}
